import { useTranslation } from 'react-i18next'

import { Link, Text } from '@enechain/ecloud-designsystem'
import { FaArrowUpRightFromSquareRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

const JMA_FORECAST_URL = 'https://www.jma.go.jp/bosai/forecast/'

/**
 * 気象データの出典 (気象庁) を明記する表示 (AC-BDB-002-1 / AC-BDB-016-1、
 * design の `気象データ：気象庁`)。
 *
 * 配置は呼び出し元が決める — design 上、一覧は page-header 右端の
 * `.bg-data-source` 行、詳細はフィルタ直下の `.region-meta` 行と異なる。
 */
export const WeatherDataSource = (): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Text textStyle="caption" color="Text.midEmphasis">
      {t('common:weatherDataSource.prefix')}
      <Link href={JMA_FORECAST_URL} rel="noopener noreferrer" target="_blank">
        {t('common:weatherDataSource.linkLabel')}
        <FaArrowUpRightFromSquareRegular
          boxSize={iconSize.externalLink}
          aria-hidden="true"
        />
      </Link>
    </Text>
  )
}
